import { render, staticRenderFns } from "./ads-consent.vue?vue&type=template&id=87e380a8&"
import script from "./ads-consent.vue?vue&type=script&lang=js&"
export * from "./ads-consent.vue?vue&type=script&lang=js&"
import style0 from "./ads-consent.less?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports